module.exports = new __parcel__URL__("menu-download.0abd0ad3.svg").toString();